import React, {Dispatch, SetStateAction, useCallback, useEffect, useState} from 'react';
import {ICurrentSelectNetwork} from "../types/type";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowCircleRight} from "@fortawesome/free-solid-svg-icons";
import {CHAIN_NETWORK_LIST} from "../pages/ArgosIdPageComponent/ChangeNetwork";
import {useTranslation} from "react-i18next";
import {toastError} from "../toast";




interface IVerifyPersonWallet {
    setNextPageAnimation: Dispatch<SetStateAction<boolean>>
    setStep: Dispatch<SetStateAction<number>>
    currentSelectNetwork: ICurrentSelectNetwork
    setCurrentSelectNetwork: Dispatch<SetStateAction<ICurrentSelectNetwork>>
}


const VerifyPersonWallet: React.FC<IVerifyPersonWallet> =
    ({
         setNextPageAnimation,
         setStep,
         currentSelectNetwork,
         setCurrentSelectNetwork
     }) => {

        const {t} = useTranslation()

        const goToChangeNetwork = useCallback(() => {
            setNextPageAnimation(true);
            setStep(999)
        }, []);

        useEffect(() => {
            if (window.ethereum) {
                window.ethereum.on('chainChanged', (chain : any) => {
                    if (chain === currentSelectNetwork.chainId) return;
                    const response = CHAIN_NETWORK_LIST.find((item) => item.chainId === chain);
                    if (!response) {
                        return toastError(t('coin-not-supported'))
                    }
                    setCurrentSelectNetwork(response);
                })
            }
        },[])


        useEffect(() => {
            if (window.ethereum && currentSelectNetwork.chainId !== 'sol') {
                const findChain = CHAIN_NETWORK_LIST.find((item) => item.chainId === window.ethereum.chainId);
                if (findChain) {
                    setCurrentSelectNetwork(findChain)
                }
            }
        }, [])


        return (
            <section className={'my-3 flex flex-col text-sm font-bold'}>
                <h4 className={'my-1.5'}>{t('verify-person-wallet')}</h4>
                <h5 className={'text-xs'}>1. {t('choose-network')}</h5>
                <div className={'flex items-center mt-3'}>
                    <div>{
                        currentSelectNetwork.chainId ?
                            currentSelectNetwork.logo
                            :
                            t('failed-to-detect-network')
                    }
                    </div>
                    <button
                        className={'rounded-md font-bold border-solid border-gray-300 bg-sky-500 px-1.5 py-1 text-xs text-white ml-1.5'}
                        onClick={goToChangeNetwork}>
                        {t('change-network')}
                        <FontAwesomeIcon icon={faArrowCircleRight} className={'ml-1.5'}/>
                    </button>
                </div>

            </section>
        )
    }
export default VerifyPersonWallet